import { render, staticRenderFns } from "./Logistics_details.vue?vue&type=template&id=4b962467&scoped=true"
import script from "./Logistics_details.vue?vue&type=script&lang=js"
export * from "./Logistics_details.vue?vue&type=script&lang=js"
import style0 from "./Logistics_details.vue?vue&type=style&index=0&id=4b962467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b962467",
  null
  
)

export default component.exports